import { render, staticRenderFns } from "./Pif.vue?vue&type=template&id=71feb2ea&"
import script from "./Pif.vue?vue&type=script&lang=js&"
export * from "./Pif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports